import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'

const EditSubjectModal = ({ show, handleClose, subject }) => {
  const [updatedSubject, setUpdatedSubject] = useState({
    subject_name: '',
    course_id: '',
  })
  const [courses, setCourses] = useState([])

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  useEffect(() => {
    if (subject) {
      setUpdatedSubject({
        subject_name: subject.subject_name || '',
        course_id: subject.course_id || '',
      })
    }
  }, [subject])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUpdatedSubject((prev) => ({ ...prev, [name]: value }))
  }

  const handleSaveChanges = async () => {
    try {
      const response = await ApiEndpoints.editSubject(
        subject.id,
        updatedSubject,
      )
      toast.success(response.data.result)
      handleClose()
    } catch (error) {
      toast.error(error.response?.data?.result)
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="bg-warning text-dark">
        <Modal.Title>Edit Subject</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Subject Name</Form.Label>
            <Form.Control
              type="text"
              name="subject_name"
              value={updatedSubject.subject_name}
              onChange={handleInputChange}
              placeholder="Enter Subject Name"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Course</Form.Label>
            <Form.Select
              name="course_id"
              value={updatedSubject.course_id}
              onChange={handleInputChange}
            >
              <option value="">Select Course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="warning" onClick={handleSaveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditSubjectModal
